// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__13ZmZ","buttonLoader":"button_buttonLoader__1t6vH","spin":"button_spin__ypVON"};